// extracted by mini-css-extract-plugin
module.exports = {"submenuList":"submenuList_submenuList__kwvJW"};